import { connect } from "react-redux";
import {
  actions,
  isSubmittingShoppingCart,
  getShoppingCart,
  getFailureSubmitShoppingCart,
  isSuccessSubmitShoppingCart
} from "../modules/shoppingCart";
import _ from "lodash/fp";
import { selectors as customerSelectors } from "../modules/customers";
import { getCurrentDealer } from "../modules/dealers";

const UpdateShoppingCart = connect(
  state => ({
    jwt: state.auth.user.jwt,
    shoppingCart: getShoppingCart(state),
    submitting: isSubmittingShoppingCart(state),
    success: isSuccessSubmitShoppingCart(state),
    failure: getFailureSubmitShoppingCart(state),
    dealerId: _.getOr(null, "id", getCurrentDealer(state)),
    customerId: _.getOr(null, "id", customerSelectors.getCurrentCustomer(state))
  }),
  {
    updateShoppingCart: actions.updateShoppingCart,
    checkoutShoppingCart: actions.checkoutShoppingCart
  }
);

export default UpdateShoppingCart;
